<script lang="ts">
  import AwardIcon from '~/icons/AwardIcon.svelte';
  import Tile from '~/board/Tile.svelte';
  import { getGame } from '~/store/GameContext.svelte';
  import { prettyDate } from '~/utils/dates';
  import GjLink from './GJLink.svelte';
  import type { Match } from '~/types';
  import type { ClassicGame } from '~/store/classic.svelte';

  type Props = {
    position?: number;
    name?: string;
    bestWord?: Match;
  };
  const props: Props = $props();
  const game = $derived(getGame<ClassicGame>().current);
</script>

<div class="container">
  <div class="row">
    <h2 class="rank">
      {#if props.position !== undefined}
        <AwardIcon size={72} />
        #{props.position}
      {/if}
    </h2>
    <h3 class="name">
      {props.name ?? ''}
    </h3>
    <h2 class="score">{game.score} pts</h2>
  </div>
  <div class="row">
    <div class="word-score"></div>
    <div class="word">
      {#each props.bestWord?.word ?? [] as letter}
        <Tile size="classic-share" tile={letter} highlighted="green" />
      {/each}
    </div>
    <div class="word-score">
      <h4>+{props.bestWord?.score ?? 0} pts</h4>
    </div>
  </div>
  <div class="row">
    <h5 class="date">
      {prettyDate(new Date().toISOString())?.replace(/, \d{4}/, '')}
    </h5>
    <GjLink />
  </div>
</div>

<style lang="scss">
  @use '../theme/theme';
  .container {
    display: grid;
    row-gap: 30px;
    height: 100%;
  }
  .row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    & * {
      margin: 0;
    }
  }
  .word {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 8px;
  }
  .rank {
    display: flex;
    align-items: center;
    & :global(svg) {
      margin-top: 12px;
      margin-right: 12px;
    }
  }
  .rank,
  .name,
  .score {
    font-size: 56px;
  }
  .rank,
  .score {
    width: 8em;
    overflow: visible;
  }
  .score {
    text-align: right;
    white-space: nowrap;
  }
  .word-score {
    font-size: 42px;
    width: 4em;
    text-align: right;
    white-space: nowrap;
  }
  .date {
    font-size: 42px;
    font-weight: 600;
    opacity: 60%;
    font-style: italic;
  }
</style>
